import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const ProfessionalBox = (props) => {
	const location = useLocation()

	return (
		<>
			{props.profs.map((prof) => (
				<div key={prof.id} className='col-md-4 col-sm-6'>
					<div className='prof_box'>
						<img src={prof.image} alt='' style={{ width: '100%' }} />
						<div className='prof_box_div'>
							<h5> {prof.name} </h5>
							<p className='mt-0 pt-0'> {prof.role} </p>
							<p>
								<span className='span1'>Worked on:</span> {prof.no_of_projects}{' '}
								{prof.no_of_projects === '1' ? (
									<span>Project</span>
								) : (
									<span>Projects</span>
								)}
							</p>
							{location.pathname == '/professionals' ||
							location.pathname == '/professionals/search' ||
							location.pathname == '/professionals/:id' ? (
								<Link to='/professionals/1' className='btn'>
									Connect with Professional
								</Link>
							) : (
								<Link to='/professionals/1' className='btn'>
									View Profile
								</Link>
							)}
						</div>
					</div>
				</div>
			))}
		</>
	)
}

export default ProfessionalBox
